import React from 'react';
import { Image } from '../../../../components/Image';
import { CamelizedArticleResponse } from '../../../../types/api';
import desktopPlaceholder from '../../../../assets/images/wellness-articles/desktop-placeholder.jpg';
import mobilePlaceholder from '../../../../assets/images/wellness-articles/mobile-placeholder.jpg';
export type WellnessHeroHeaderImageProps = Pick<CamelizedArticleResponse, 'heroImageUrl'> & {
  slug: string;
};
export const WellnessHeroHeaderImage = ({
  heroImageUrl,
  slug
}: WellnessHeroHeaderImageProps) => <Image alt={`wellness-${slug}-hero-image`} borderRadius={['0px', '8px']} height={['250px', '360px', '555px']} width={['100%', null, '832px']} src={heroImageUrl || [mobilePlaceholder, null, desktopPlaceholder]} data-sentry-element="Image" data-sentry-component="WellnessHeroHeaderImage" data-sentry-source-file="index.tsx" />;